import { TextLinkWidget } from '@tableau/widgets';
import * as React from 'react';
import { SessionSiteSelectors } from '../../../../app/selectors/SessionInfoSelectors';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { HelpService } from '../../../../commonInfra/services/HelpService';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { learnMoreStyle } from '../../../styles/CommonStyles';
import { useSelector } from '../../utils';
import { SiteSettingsForSiteAdminProps } from '../ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export const AUTO_ACCESS_FIELD = 'settings.derivedPermissionsEnabled';

export type AutomaticAccessSectionProps = SiteSettingsForSiteAdminProps<'derivedPermissionsEnabled'>

export function AutomaticAccessSection(props: AutomaticAccessSectionProps) {
  const catalogingOnSiteEnabled = useSelector(SessionSiteSelectors.isCatalogingOnSiteEnabled);
  return FeatureFlags.metadataAreaEnabled
    ? (
      <SettingsSection title={Messages.derivedPermissionsSettingsHeader()}
                       testId={'auto-access-setting-section'}
                       description={renderDescription(catalogingOnSiteEnabled)}>
        <FormikCheckbox name={AUTO_ACCESS_FIELD}
                        label={Messages.derivedPermissionsSettingCheckboxLabel()}
                        testId={'allow-derived-permissions-checkbox'}
        />
      </SettingsSection>
    )
    : null;
}

function renderDescription(catalogingOnSiteEnabled: boolean) {
  return <>
      <span data-tb-test-id={'auto-access-description'}>{catalogingOnSiteEnabled
        ? Messages.derivedPermissionsSettingDetails1DM()
        : Messages.derivedPermissionsSettingDetails1Baseline()}
      </span>
      <TextLinkWidget testId={'derived-permissions-learn-more-link'}
                      className={learnMoreStyle}
                      href={HelpService.getServerHelpUrlByCategory('dm-derived')}
                      target={'_blank'}>
        {Messages.derivedPermissionsLearnMore()}
      </TextLinkWidget>
    </>;
}

export const AutomaticAccessSectionSpecs = componentRegistryEntry({
  name: 'AutomaticAccessSection',
  component: AutomaticAccessSection
});
